import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import moment from 'moment-timezone';
import React, { useMemo } from 'react';

const Scheduler = ({ question }) => {
  const options = question.question_possible_answers;
  const { type } = question.question_settings;

  return (
    <Box>
      <Typography paragraph variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <Grid container spacing={3}>
        {options?.map((choice) => (
          <Grid item key={choice.id}>
            <Button variant="outlined" sm={3}>
              {type === 'recurring' &&
                moment
                  .utc()
                  .startOf('day')
                  .day(choice.dow)
                  .minute(choice.time)
                  .format('dddd, h:mm a')}
              {type === 'fixed' &&
                moment(choice.date).format('MMMM Do, h:mm a')}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Scheduler;
